import { render, staticRenderFns } from "./m-logout.vue?vue&type=template&id=a76183a6&"
import script from "./m-logout.vue?vue&type=script&lang=js&"
export * from "./m-logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports